import React, { cloneElement } from 'react';
import { Check, ChevronRight, BookOpen, Droplet, Calculator, Package, Calendar, Smartphone, Coffee, Gift, ShoppingBag, Star, X } from 'lucide-react';
import { FAQ } from './components/FAQ';
export function App() {
  return <div className="min-h-screen bg-[#F7F1E8] font-['Inter',sans-serif] text-[#5A3A28] selection:bg-[#E8B3C1] selection:text-[#5A3A28]" data-id="element-0" data-mp="3k92rqa47ciqj">
      {/* 1. HERO SECTION */}
      <section id="hero" className="relative py-8 px-6 lg:px-12 max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-1" data-mp="2rk47n7gir6il">
        <div className="flex-1 z-10 w-full max-w-2xl lg:max-w-none mx-auto" data-id="element-2" data-mp="2mjpwhgjmfggc">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#EF9F27] text-white font-semibold text-sm mb-8 shadow-sm" data-id="element-3" data-mp="31c9vq63nh3si">
            <span data-id="element-4" data-mp="28ufmg62gz4gf">🔥 Precio de lanzamiento — Solo por tiempo limitado</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-[1.1] text-[#5A3A28]" data-id="element-5" data-mp="23vcjcr61v8b3">
            EMPRENDÉ CON <span className="text-[#ED93B1]" data-id="element-6" data-mp="3iiwdijzxza14">MINICOOKIES</span>{' '}
            DESDE TU CASA
          </h1>

          <p className="text-lg sm:text-xl text-[#5A3A28]/80 mb-8 font-medium leading-relaxed" data-id="element-7" data-mp="3mk86mzi0yde2">
            Aprendé a producir, presentar y vender minicookies irresistibles con
            una app interactiva lista para usar.
          </p>

          <ul className="space-y-4 mb-10" data-id="element-8" data-mp="7suzhf7pr6a">
            {['Recetas probadas', 'Costos y precios sugeridos', 'Packaging recomendado', 'Plan para conseguir tus primeras ventas'].map((item, i) => <li key={i} className="flex items-center gap-3 text-lg font-medium" data-id="element-9" data-mp="33mykhalbelt4" data-mpi={i}>
                <div className="bg-[#C98A4B] rounded-full p-1" data-id="element-10" data-mp="38l00tnrcw70w">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-11" data-mp="3dle30p6a0mr0" />
                </div>
                {item}
              </li>)}
          </ul>

          <div className="flex" data-id="element-12" data-mp="nvasltl5rjh6">
            <a href="#que-incluye" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-transparent hover:bg-[#5A3A28]/5 text-[#5A3A28] rounded-full font-bold text-lg transition-colors duration-300 border-2 border-[#5A3A28]/20 hover:border-[#5A3A28]" data-id="element-13" data-mp="sudk0b87tr6o">
              VER TODO LO QUE INCLUYE
            </a>
          </div>

          <p className="mt-4 text-sm text-[#5A3A28]/70 font-medium" data-id="element-14" data-mp="d45v27vesjoo">
            🔒 Acceso inmediato · De por vida · Sin suscripción
          </p>
        </div>

        <div className="flex-1 relative w-full max-w-2xl lg:max-w-none mx-auto" data-id="element-15" data-mp="3gkla21uate6j">
          <div className="absolute inset-0 bg-[#E8B3C1]/20 rounded-[2.5rem] transform rotate-3 scale-105 -z-10" data-id="element-16" data-mp="3bmjsxmgfnoxp"></div>
          <img src="https://cdn.magicpatterns.com/uploads/7Qsv58MeAQsJJ5h3eAKBBH/ChatGPT_Image_17_jun_2026,_07_48_28_p.m..png" alt="Minicookies Premium Mockup" className="rounded-[2.5rem] shadow-2xl object-cover w-full h-auto aspect-[4/5] lg:aspect-square" data-id="element-17" data-mp="3qbfwb67jodrz" />
        </div>
      </section>

      {/* 2. QUÉ INCLUYE */}
      <section id="que-incluye" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-white" data-id="element-18" data-mp="2sv0p5del46um">
        <div className="max-w-[1400px] mx-auto" data-id="element-19" data-mp="18dhukbo9re9p">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-16 text-[#5A3A28]" data-id="element-20" data-mp="18bomcry0clzl">
            ¿QUÉ INCLUYE MINICOOKIES LAB?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-21" data-mp="ygmsjissevqo">
            {[{
            icon: <BookOpen data-id="element-22" data-mp="13fpx724uuzy4" />,
            title: 'Recetas Premium',
            desc: 'Fórmulas exactas para cookies perfectas.'
          }, {
            icon: <Droplet data-id="element-23" data-mp="1r2g1ka4of6lw" />,
            title: 'Salsas para Dipping',
            desc: 'Complementos irresistibles para tus ventas.'
          }, {
            icon: <Calculator data-id="element-24" data-mp="1i2j8lwb97ll1" />,
            title: 'Costos y Precios',
            desc: 'Calculadora automática de rentabilidad.'
          }, {
            icon: <Package data-id="element-25" data-mp="1m70qtr1ytqtp" />,
            title: 'Packaging y Conservación',
            desc: 'Presentaciones que enamoran a tus clientes.'
          }, {
            icon: <Calendar data-id="element-26" data-mp="aqsj7b7ofpb6" />,
            title: 'Planner de Producción',
            desc: 'Organización paso a paso para escalar.'
          }, {
            icon: <Smartphone data-id="element-27" data-mp="m6fayl65ulfs" />,
            title: 'App Interactiva',
            desc: 'Todo tu negocio en la palma de tu mano.'
          }].map((item, i) => <div key={i} className="bg-[#F7F1E8] p-8 rounded-3xl border border-[#5A3A28]/10 hover:border-[#C98A4B] transition-colors duration-300 flex flex-col items-center text-center group" data-id="element-28" data-mp="h8dso2gk6q5d" data-mpi={i}>
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-[#C98A4B] mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-29" data-mp="19uyiuzlasw7c">
                  {cloneElement(item.icon, {
                className: 'w-8 h-8'
              })}
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-30" data-mp="vvgps80yyws6">{item.title}</h3>
                <p className="text-[#5A3A28]/70 font-medium" data-id="element-31" data-mp="3kokm7g59f70f">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* COMPARATIVA: NO ES OTRO PDF */}
      <section id="comparativa" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-[#E8B3C1]/10" data-id="element-32" data-mp="1w4f4urx4rjp6">
        <div className="max-w-[1000px] mx-auto text-center" data-id="element-33" data-mp="2060aptb8yxpv">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4 text-[#5A3A28]" data-id="element-34" data-mp="206jsna0wdm3w">
            No es otro PDF
          </h2>
          <p className="text-lg md:text-xl text-[#5A3A28]/80 font-medium mb-12" data-id="element-35" data-mp="2530kofb7wkm9">
            Es una herramienta interactiva diseñada para ayudarte a vender.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 text-left" data-id="element-36" data-mp="2euemitqn5wik">
            {/* PDF */}
            <div className="bg-white p-8 rounded-3xl border border-[#5A3A28]/10 opacity-70" data-id="element-37" data-mp="2js6e1mndjgm8">
              <h3 className="text-xl font-bold mb-6 text-[#5A3A28]/60" data-id="element-38" data-mp="2nw4crw8seper">
                PDF tradicional
              </h3>
              <ul className="space-y-4" data-id="element-39" data-mp="2ssla9h1vmg4i">
                {['Información dispersa', 'Solo lectura', 'Sin herramientas', 'Difícil de consultar mientras trabajás'].map((item, i) => <li key={i} className="flex items-center gap-3 text-[#5A3A28]/70 font-medium" data-id="element-40" data-mp="yhg1jybxndib" data-mpi={i}>
                    <X className="w-5 h-5 text-red-400 shrink-0" data-id="element-41" data-mp="21sddlzpkljf4" />
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* Minicookies Lab */}
            <div className="bg-[#5A3A28] p-8 rounded-3xl shadow-xl text-[#F7F1E8] transform md:-translate-y-2" data-id="element-42" data-mp="2atbkcpre851e">
              <h3 className="text-xl font-bold mb-6 text-[#EF9F27]" data-id="element-43" data-mp="25se5am1ojr44">
                Minicookies <span className="text-[#ED93B1]" data-id="element-44" data-mp="2kpn23v9r5n38">Lab</span>
              </h3>
              <ul className="space-y-4" data-id="element-45" data-mp="2frlecx1dszlf">
                {['Todo organizado', 'Acceso inmediato desde celular', 'Calculadora incluida', 'Sistema paso a paso', 'Herramientas para vender'].map((item, i) => <li key={i} className="flex items-center gap-3 font-medium" data-id="element-46" data-mp="2ph4y04wx4xhc" data-mpi={i}>
                    <Check className="w-5 h-5 text-[#EF9F27] shrink-0" strokeWidth={3} data-id="element-47" data-mp="2pj9cfgsg1evv" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <p className="text-2xl font-extrabold text-[#5A3A28]" data-id="element-48" data-mp="2yjo0gnwsl832">
            Más que recetas. Un sistema completo para emprender.
          </p>
        </div>
      </section>

      {/* 3. MIRÁ LA APP POR DENTRO */}
      <section id="app" className="py-8 px-0 overflow-hidden" data-id="element-49" data-mp="3n0dchconnss7">
        <h2 className="sr-only" data-id="element-50" data-mp="384nml3gcmvi7">
          Mirá la app por dentro — todo lo que necesitás para emprender,
          organizado paso a paso
        </h2>
        <div className="m-0 p-0 overflow-hidden bg-black" data-id="element-51" data-mp="2zd54gmzue5mh">
          <img src="https://cdn.magicpatterns.com/uploads/sdPsykQ6HWFBv9BWR7coUf/ChatGPT_Image_22_jun_2026,_08_21_15_p.m..png" alt="Mirá la app por dentro: pantallas reales de recetas, primeras ventas y producción de la app Minicookies Lab" className="block w-full h-auto m-0 p-0 rounded-none border-0 shadow-none" data-id="element-52" data-mp="2zbu3sw1p1dzl" />
        </div>
      </section>

      {/* 4. LO QUE PODÉS VENDER */}
      <section id="vender" className="py-8 px-6 lg:px-12 bg-white" data-id="element-53" data-mp="2gfkflfx2v71v">
        <div className="max-w-[1400px] mx-auto" data-id="element-54" data-mp="2kge3i9aislur">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-16 text-[#5A3A28]" data-id="element-55" data-mp="2kf30ibowfi4p">
            LO QUE PODÉS VENDER
          </h2>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2" data-id="element-56" data-mp="2vvr6u03lxivs">
            {[{
            title: 'Vasos de minicookies',
            desc: 'El formato estrella para consumo al paso.',
            icon: <Coffee className="w-5 h-5" data-id="element-57" data-mp="2lyd0itbeeah7" />
          }, {
            title: 'Bandejas para compartir',
            desc: 'Ideales para reuniones y regalos.',
            icon: <ShoppingBag className="w-5 h-5" data-id="element-58" data-mp="2hym4aa33r25a" />
          }, {
            title: 'Souvenirs',
            desc: 'Para cumpleaños, bodas y eventos.',
            icon: <Gift className="w-5 h-5" data-id="element-59" data-mp="285wxvtmesegt" />
          }, {
            title: 'Mesas dulces',
            desc: 'Propuestas premium para fiestas.',
            icon: <Star className="w-5 h-5" data-id="element-60" data-mp="235ioa755swgo" />
          }].map((item, i) => <div key={i} className="group relative rounded-2xl bg-[#F7F1E8] border border-[#5A3A28]/10 flex flex-col items-center justify-center px-[14px] py-[12px] text-center hover:bg-[#5A3A28] hover:text-white transition-colors duration-300" data-id="element-61" data-mp="1y7h39go6an2k" data-mpi={i}>
                <div className="text-[#C98A4B] mb-[4px] group-hover:text-[#E8B3C1] transition-colors" data-id="element-62" data-mp="9r8s6dhivwts">
                  {item.icon}
                </div>
                <h3 className="text-[13px] font-bold mb-[2px]" data-id="element-63" data-mp="iqvy9cl75qt6">{item.title}</h3>
                <p className="text-[11px] leading-[1.4] opacity-80 font-medium" data-id="element-64" data-mp="noxhpymjbs56">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 5. IDEAL PARA VOS SI... */}
      <section id="ideal" className="py-8 px-6 lg:px-12 relative" data-id="element-65" data-mp="3r5xfa5it8keo">
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: `url('https://cdn.magicpatterns.com/uploads/wnNrC9o8oofHrx9j3yxmfZ/ChatGPT_Image_18_jun_2026,_04_25_18_p.m..png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }} data-id="element-66" data-mp="3w47bmjg9tr1v"></div>
        <div className="max-w-3xl mx-auto relative z-10 bg-white/90 backdrop-blur-md p-10 md:p-16 rounded-[2.5rem] shadow-xl border border-[#5A3A28]/10" data-id="element-67" data-mp="38duy8t29b23w">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-10 text-[#5A3A28]" data-id="element-68" data-mp="2k6827l62kj58">
            IDEAL PARA VOS SI...
          </h2>

          <ul className="space-y-6" data-id="element-69" data-mp="2p6cm7l66rw07">
            {['Querés generar ingresos desde casa', 'Te gusta la cocina y los detalles', 'Buscás un emprendimiento de baja inversión', 'Querés vender por Instagram y WhatsApp', 'Necesitás un sistema paso a paso comprobado'].map((text, i) => <li key={i} className="flex items-center gap-4 text-lg md:text-xl font-medium" data-id="element-70" data-mp="21fgwctlajavl" data-mpi={i}>
                <div className="bg-[#E8B3C1] rounded-full p-1 shrink-0" data-id="element-71" data-mp="26f3ad58y0v5g">
                  <Check className="w-5 h-5 text-[#5A3A28]" strokeWidth={3} data-id="element-72" data-mp="26cqju3p4dcgs" />
                </div>
                {text}
              </li>)}
          </ul>
        </div>
      </section>

      {/* AUTORIDAD */}
      <section id="autoridad" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-white text-center" data-id="element-73" data-mp="1dobgwfj9iklt">
        <div className="max-w-3xl mx-auto" data-id="element-74" data-mp="1imw7rocmjrxl">
          <div className="w-16 h-16 bg-[#E8B3C1]/30 rounded-full flex items-center justify-center mx-auto mb-6 text-[#5A3A28]" data-id="element-75" data-mp="3vzsabtk92ew7">
            <Star className="w-8 h-8 fill-current" data-id="element-76" data-mp="3ryf1rbprvxll" />
          </div>
          <h2 className="text-3xl font-extrabold mb-6 text-[#5A3A28]" data-id="element-77" data-mp="3my13umhvy41a">
            Creada para emprendedoras reales
          </h2>
          <p className="text-lg md:text-xl text-[#5A3A28]/80 font-medium leading-relaxed" data-id="element-78" data-mp="3hz7sp0q2mp4a">
            Pensada para quienes quieren comenzar desde casa con baja inversión,
            vender por Instagram, WhatsApp, ferias o pedidos personalizados y
            transformar una receta en un negocio.
          </p>
        </div>
      </section>

      {/* URGENCY BAND */}
      <section id="lanzamiento" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-[#EF9F27] text-[#5A3A28] text-center" data-id="element-79" data-mp="2za15p1i8vbco">
        <div className="max-w-4xl mx-auto" data-id="element-80" data-mp="2u8txj1c6wa5h">
          <h2 className="text-2xl md:text-3xl font-extrabold mb-4 flex items-center justify-center gap-2" data-id="element-81" data-mp="2pb23o1rzidyn">
            🔥 Precio de lanzamiento
          </h2>
          <p className="text-lg font-bold" data-id="element-82" data-mp="2flv6v8l5pjrt">
            Acceso de por vida. Actualizaciones futuras incluidas.{' '}
            <br className="hidden md:block" data-id="element-83" data-mp="2kkg6p6why1fq" />
            <span className="font-medium opacity-90" data-id="element-84" data-mp="26n9u5u2d8yyy">
              El valor aumentará cuando se agreguen nuevos módulos y
              herramientas.
            </span>
          </p>
        </div>
      </section>

      {/* 6. OFERTA */}
      <section id="oferta" className="py-8 px-6 lg:px-12 bg-[#5A3A28] text-[#F7F1E8]" data-id="element-85" data-mp="2yeh8k9iqw4kb">
        <div className="max-w-4xl mx-auto text-center" data-id="element-86" data-mp="33bpixnxnj4b0">
          <div className="inline-block bg-[#EF9F27] text-[#5A3A28] px-6 py-2 rounded-full font-bold tracking-widest text-sm mb-8 uppercase" data-id="element-87" data-mp="2plvs502l69yn">
            ⭐ Oferta de lanzamiento
          </div>

          <h2 className="text-4xl md:text-5xl font-extrabold mb-8" data-id="element-88" data-mp="3hctl858v7wkn">
            Empezá esta semana
          </h2>

          <div className="flex flex-col items-center mb-12" data-id="element-89" data-mp="3m41u906a9fxa">
            <span className="text-2xl text-[#F7F1E8]/50 line-through font-medium" data-id="element-90" data-mp="3m5mpks0f92w7">
              USD $22
            </span>
            <span className="text-5xl md:text-6xl font-extrabold text-white mt-1" data-id="element-91" data-mp="15pq10p0r8tqq">
              USD $12.00
            </span>
            <span className="text-base text-[#F7F1E8]/80 font-medium mt-3" data-id="element-92" data-mp="1kema8pejscsx">
              Pago seguro internacional · Tarjeta de crédito o débito
            </span>
            <span className="mt-2 max-w-md text-center text-[13px] font-normal leading-snug text-[#EF9F27]/80" data-id="element-93" data-mp="rpp23f41vwdw">
              Se cobra en dólares — tu banco lo convierte automáticamente a tu
              moneda local al momento del pago
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-4 text-left max-w-xl mx-auto mb-12" data-id="element-94" data-mp="11p62bh0j9i2h">
            {['Recetas probadas', 'Calculadora de costos', 'Packaging recomendado', 'Plan para primeras ventas', 'Acceso inmediato'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-95" data-mp="284glj2j7xtb2" data-mpi={i}>
                <Check className="w-5 h-5 text-[#EF9F27] shrink-0" strokeWidth={3} data-id="element-96" data-mp="2869pga2g5zfd" />
                <span className="font-medium text-lg" data-id="element-97" data-mp="howeipgzubtk">{item}</span>
              </div>)}
          </div>

          <a href="https://pay.hotmart.com/B107463740X" target="_blank" rel="noopener" className="w-full sm:w-auto group relative inline-flex items-center justify-center gap-2 px-10 py-5 bg-[#22C55E] hover:bg-[#16A34A] text-white rounded-full font-extrabold text-xl transition-[transform,background-color,box-shadow] duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1" data-id="element-98" data-mp="mo0mxdw3g5iu">
            QUIERO ACCEDER AHORA
            <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-99" data-mp="15ifptelj0iby" />
          </a>

          <p className="mt-6 text-sm text-[#F7F1E8]/70 font-medium" data-id="element-100" data-mp="1ed2mnmd4jmcl">
            Acceso de por vida • Sin suscripciones • Disponible desde cualquier
            dispositivo
          </p>
        </div>
      </section>

      {/* PREGUNTAS FRECUENTES */}
      <FAQ data-id="element-101" data-mp="1obrx4u2oy4it" />
    </div>;
}